import { lazy } from "react"

export const OrderAnalyticsPage = lazy(() => import("./OrderAnalyticsPage"))